// @ts-ignore
/* eslint-disable */
import request from '@/utils/request';

/** ListAPIKeys GET /gradmin/api-keys */
export async function getGradminApiKeys(options?: { [key: string]: any }) {
  return request<any>('/gradmin/api-keys', {
    method: 'GET',
    ...(options || {}),
  });
}

/** DeleteAPIKey DELETE /gradmin/api-keys/${param0} */
export async function deleteGradminApiKeysId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminApiKeysIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/api-keys/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DisableAPIKey PATCH /gradmin/api-keys/${param0}/disable */
export async function patchGradminApiKeysIdDisable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminApiKeysIdDisableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/api-keys/${param0}/disable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** EnableAPIKey PATCH /gradmin/api-keys/${param0}/enable */
export async function patchGradminApiKeysIdEnable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminApiKeysIdEnableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/api-keys/${param0}/enable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** GetDashboardStatsHandler GET /gradmin/dashboard/stats */
export async function getGradminDashboardStats(options?: { [key: string]: any }) {
  return request<any>('/gradmin/dashboard/stats', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListEmployees GET /gradmin/employees */
export async function getGradminEmployees(options?: { [key: string]: any }) {
  return request<API.EmployeeListItem[]>('/gradmin/employees', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateEmployee POST /gradmin/employees */
export async function postGradminEmployees(
  body: API.CreateEmployeeRequest,
  options?: { [key: string]: any }
) {
  return request<API.EmployeeListItem>('/gradmin/employees', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** UpdateEmployee PUT /gradmin/employees/${param0} */
export async function putGradminEmployeesId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminEmployeesIdParams,
  body: API.UpdateEmployeeRequest,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.EmployeeListItem>(`/gradmin/employees/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** DeleteEmployee DELETE /gradmin/employees/${param0} */
export async function deleteGradminEmployeesId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminEmployeesIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<Record<string, any>>(`/gradmin/employees/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ResetEmployeePassword POST /gradmin/employees/${param0}/reset-password */
export async function postGradminEmployeesIdResetPassword(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminEmployeesIdResetPasswordParams,
  body: API.ResetEmployeePasswordRequest,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<Record<string, any>>(`/gradmin/employees/${param0}/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** UpdateEmployeeStatus PATCH /gradmin/employees/${param0}/status */
export async function patchGradminEmployeesIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminEmployeesIdStatusParams,
  body: API.UpdateEmployeeStatusRequest,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<Record<string, any>>(`/gradmin/employees/${param0}/status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** ListFunctions GET /gradmin/functions */
export async function getGradminFunctions(options?: { [key: string]: any }) {
  return request<any>('/gradmin/functions', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateFunction POST /gradmin/functions */
export async function postGradminFunctions(options?: { [key: string]: any }) {
  return request<any>('/gradmin/functions', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateFunction PUT /gradmin/functions/${param0} */
export async function putGradminFunctionsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminFunctionsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/functions/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteFunction DELETE /gradmin/functions/${param0} */
export async function deleteGradminFunctionsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminFunctionsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/functions/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListGuardrails GET /gradmin/guardrails */
export async function getGradminGuardrails(options?: { [key: string]: any }) {
  return request<any>('/gradmin/guardrails', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateGuardrail POST /gradmin/guardrails */
export async function postGradminGuardrails(options?: { [key: string]: any }) {
  return request<any>('/gradmin/guardrails', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateGuardrail PUT /gradmin/guardrails/${param0} */
export async function putGradminGuardrailsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminGuardrailsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/guardrails/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteGuardrail DELETE /gradmin/guardrails/${param0} */
export async function deleteGradminGuardrailsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminGuardrailsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/guardrails/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListOrganizationsSimple GET /gradmin/guardrails/organizations */
export async function getGradminGuardrailsOrganizations(options?: { [key: string]: any }) {
  return request<any>('/gradmin/guardrails/organizations', {
    method: 'GET',
    ...(options || {}),
  });
}

/** AdminLogoutHandler POST /gradmin/logout */
export async function postGradminLogout(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** GetLogsHandler GET /gradmin/logs */
export async function getGradminLogs(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetLogDetailHandler GET /gradmin/logs/detail */
export async function getGradminLogsDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminLogsDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.LogDetailResponse>('/gradmin/logs/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** ExportLogsHandler GET /gradmin/logs/export */
export async function getGradminLogsOpenApiExport(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/export', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetAllFilterOptionsHandler GET /gradmin/logs/filter-options */
export async function getGradminLogsFilterOptions(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/filter-options', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetLogsAPIKeysHandler GET /gradmin/logs/filter-options/api-keys */
export async function getGradminLogsFilterOptionsApiKeys(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/filter-options/api-keys', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetLogsModelsHandler GET /gradmin/logs/filter-options/models */
export async function getGradminLogsFilterOptionsModels(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/filter-options/models', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetLogsOrganizationsHandler GET /gradmin/logs/filter-options/organizations */
export async function getGradminLogsFilterOptionsOrganizations(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/filter-options/organizations', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetLogsProjectsHandler GET /gradmin/logs/filter-options/projects */
export async function getGradminLogsFilterOptionsProjects(options?: { [key: string]: any }) {
  return request<any>('/gradmin/logs/filter-options/projects', {
    method: 'GET',
    ...(options || {}),
  });
}

/** AdminMeHandler GET /gradmin/me */
export async function getGradminMe(options?: { [key: string]: any }) {
  return request<any>('/gradmin/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListModels GET /gradmin/models */
export async function getGradminModels(options?: { [key: string]: any }) {
  return request<any>('/gradmin/models', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateModel POST /gradmin/models */
export async function postGradminModels(options?: { [key: string]: any }) {
  return request<any>('/gradmin/models', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateModel PUT /gradmin/models/${param0} */
export async function putGradminModelsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminModelsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/models/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteModel DELETE /gradmin/models/${param0} */
export async function deleteGradminModelsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminModelsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/models/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateModelStatus PATCH /gradmin/models/${param0}/status */
export async function patchGradminModelsIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminModelsIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/models/${param0}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAllModels GET /gradmin/models/all */
export async function getGradminModelsAll(options?: { [key: string]: any }) {
  return request<any>('/gradmin/models/all', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListOrganizations GET /gradmin/organizations */
export async function getGradminOrganizations(options?: { [key: string]: any }) {
  return request<any>('/gradmin/organizations', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateOrganization POST /gradmin/organizations */
export async function postGradminOrganizations(options?: { [key: string]: any }) {
  return request<any>('/gradmin/organizations', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateOrganization PUT /gradmin/organizations/${param0} */
export async function putGradminOrganizationsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminOrganizationsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteOrganization DELETE /gradmin/organizations/${param0} */
export async function deleteGradminOrganizationsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminOrganizationsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListCreditLedger GET /gradmin/organizations/${param0}/credit-ledger */
export async function getGradminOrganizationsIdCreditLedger(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminOrganizationsIdCreditLedgerParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}/credit-ledger`, {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      // page_size has a default value: 10
      page_size: '10',
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** GetOrganizationMembers GET /gradmin/organizations/${param0}/members */
export async function getGradminOrganizationsIdMembers(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminOrganizationsIdMembersParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}/members`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateOrganizationStatus PATCH /gradmin/organizations/${param0}/status */
export async function patchGradminOrganizationsIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminOrganizationsIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Topup POST /gradmin/organizations/${param0}/topup */
export async function postGradminOrganizationsIdTopup(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminOrganizationsIdTopupParams,
  body: API.TopupRequest,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/organizations/${param0}/topup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** AdminChangePasswordHandler POST /gradmin/password */
export async function postGradminPassword(options?: { [key: string]: any }) {
  return request<any>('/gradmin/password', {
    method: 'POST',
    ...(options || {}),
  });
}

/** GetModelPricing GET /gradmin/pricing */
export async function getGradminPricing(options?: { [key: string]: any }) {
  return request<any>('/gradmin/pricing', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreatePricing POST /gradmin/pricing */
export async function postGradminPricing(options?: { [key: string]: any }) {
  return request<any>('/gradmin/pricing', {
    method: 'POST',
    ...(options || {}),
  });
}

/** DeletePricing DELETE /gradmin/pricing/${param0}/${param1} */
export async function deleteGradminPricingTypeId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminPricingTypeIdParams,
  options?: { [key: string]: any }
) {
  const { type: param0, id: param1, ...queryParams } = params;
  return request<any>(`/gradmin/pricing/${param0}/${param1}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListProjects GET /gradmin/projects */
export async function getGradminProjects(options?: { [key: string]: any }) {
  return request<any>('/gradmin/projects', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateProject POST /gradmin/projects */
export async function postGradminProjects(options?: { [key: string]: any }) {
  return request<any>('/gradmin/projects', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateProject PUT /gradmin/projects/${param0} */
export async function putGradminProjectsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminProjectsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/projects/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteProject DELETE /gradmin/projects/${param0} */
export async function deleteGradminProjectsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminProjectsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/projects/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DisableProject PATCH /gradmin/projects/${param0}/disable */
export async function patchGradminProjectsIdDisable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminProjectsIdDisableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/projects/${param0}/disable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** EnableProject PATCH /gradmin/projects/${param0}/enable */
export async function patchGradminProjectsIdEnable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminProjectsIdEnableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/projects/${param0}/enable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListOrganizationsSimple GET /gradmin/projects/organizations */
export async function getGradminProjectsOrganizations(options?: { [key: string]: any }) {
  return request<any>('/gradmin/projects/organizations', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListFoldersByOrganization GET /gradmin/projects/organizations/${param0}/folders */
export async function getGradminProjectsOrganizationsIdFolders(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminProjectsOrganizationsIdFoldersParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/projects/organizations/${param0}/folders`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListProviderAccounts GET /gradmin/provider-accounts */
export async function getGradminProviderAccounts(options?: { [key: string]: any }) {
  return request<any>('/gradmin/provider-accounts', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateProviderAccount POST /gradmin/provider-accounts */
export async function postGradminProviderAccounts(options?: { [key: string]: any }) {
  return request<any>('/gradmin/provider-accounts', {
    method: 'POST',
    ...(options || {}),
  });
}

/** GetProviderAccount GET /gradmin/provider-accounts/${param0} */
export async function getGradminProviderAccountsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminProviderAccountsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateProviderAccount PUT /gradmin/provider-accounts/${param0} */
export async function putGradminProviderAccountsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminProviderAccountsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteProviderAccount DELETE /gradmin/provider-accounts/${param0} */
export async function deleteGradminProviderAccountsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminProviderAccountsIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateProviderAccountAPIKey PUT /gradmin/provider-accounts/${param0}/api-key */
export async function putGradminProviderAccountsIdApiKey(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminProviderAccountsIdApiKeyParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/api-key`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** CopyProviderAccount POST /gradmin/provider-accounts/${param0}/copy */
export async function postGradminProviderAccountsIdCopy(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminProviderAccountsIdCopyParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/copy`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAccountModels GET /gradmin/provider-accounts/${param0}/models */
export async function getGradminProviderAccountsIdModels(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminProviderAccountsIdModelsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** AddAccountModel POST /gradmin/provider-accounts/${param0}/models */
export async function postGradminProviderAccountsIdModels(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminProviderAccountsIdModelsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateAccountModel PUT /gradmin/provider-accounts/${param0}/models/${param1} */
export async function putGradminProviderAccountsIdModelsModelId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminProviderAccountsIdModelsModelIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, model_id: param1, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models/${param1}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteAccountModel DELETE /gradmin/provider-accounts/${param0}/models/${param1} */
export async function deleteGradminProviderAccountsIdModelsModelId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminProviderAccountsIdModelsModelIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, model_id: param1, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models/${param1}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateAccountModelStatus PATCH /gradmin/provider-accounts/${param0}/models/${param1}/status */
export async function patchGradminProviderAccountsIdModelsModelIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminProviderAccountsIdModelsModelIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, model_id: param1, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models/${param1}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** BatchDeleteAccountModels POST /gradmin/provider-accounts/${param0}/models/batch-delete */
export async function postGradminProviderAccountsIdModelsBatchDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminProviderAccountsIdModelsBatchDeleteParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/models/batch-delete`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateProviderAccountStatus PATCH /gradmin/provider-accounts/${param0}/status */
export async function patchGradminProviderAccountsIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminProviderAccountsIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/provider-accounts/${param0}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAllProviderAccounts GET /gradmin/provider-accounts/all */
export async function getGradminProviderAccountsAll(options?: { [key: string]: any }) {
  return request<any>('/gradmin/provider-accounts/all', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListProviders GET /gradmin/providers */
export async function getGradminProviders(options?: { [key: string]: any }) {
  return request<any>('/gradmin/providers', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateProvider POST /gradmin/providers */
export async function postGradminProviders(options?: { [key: string]: any }) {
  return request<any>('/gradmin/providers', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateProvider PUT /gradmin/providers/${param0} */
export async function putGradminProvidersId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminProvidersIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/providers/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteProvider DELETE /gradmin/providers/${param0} */
export async function deleteGradminProvidersId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminProvidersIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/providers/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAccountsByProvider GET /gradmin/providers/${param0}/accounts */
export async function getGradminProvidersIdAccounts(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminProvidersIdAccountsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/providers/${param0}/accounts`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateProviderStatus PATCH /gradmin/providers/${param0}/status */
export async function patchGradminProvidersIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminProvidersIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/providers/${param0}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListProvidersWithAccountCount GET /gradmin/providers/with-accounts-count */
export async function getGradminProvidersWithAccountsCount(options?: { [key: string]: any }) {
  return request<any>('/gradmin/providers/with-accounts-count', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GetAdminReportHandler GET /gradmin/reports/token-usage */
export async function getGradminReportsTokenUsage(options?: { [key: string]: any }) {
  return request<any>('/gradmin/reports/token-usage', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ExportTokenUsageHandler GET /gradmin/reports/token-usage/export */
export async function getGradminReportsTokenUsageOpenApiExport(options?: { [key: string]: any }) {
  return request<any>('/gradmin/reports/token-usage/export', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ListRoles GET /gradmin/roles */
export async function getGradminRoles(options?: { [key: string]: any }) {
  return request<any>('/gradmin/roles', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateRole POST /gradmin/roles */
export async function postGradminRoles(options?: { [key: string]: any }) {
  return request<any>('/gradmin/roles', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateRole PUT /gradmin/roles/${param0} */
export async function putGradminRolesId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminRolesIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteRole DELETE /gradmin/roles/${param0} */
export async function deleteGradminRolesId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminRolesIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DisableRole PATCH /gradmin/roles/${param0}/disable */
export async function patchGradminRolesIdDisable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminRolesIdDisableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}/disable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** EnableRole PATCH /gradmin/roles/${param0}/enable */
export async function patchGradminRolesIdEnable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminRolesIdEnableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}/enable`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** GetRoleFunctions GET /gradmin/roles/${param0}/functions */
export async function getGradminRolesIdFunctions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminRolesIdFunctionsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}/functions`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** SaveRoleFunctions POST /gradmin/roles/${param0}/functions */
export async function postGradminRolesIdFunctions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminRolesIdFunctionsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/roles/${param0}/functions`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAllCreditLedger GET /gradmin/topup-records */
export async function getGradminTopupRecords(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminTopupRecordsParams,
  options?: { [key: string]: any }
) {
  return request<any>('/gradmin/topup-records', {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      // page_size has a default value: 20
      page_size: '20',

      ...params,
    },
    ...(options || {}),
  });
}

/** ExportCreditLedger GET /gradmin/topup-records/export */
export async function getGradminTopupRecordsOpenApiExport(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminTopupRecords_openAPI_exportParams,
  options?: { [key: string]: any }
) {
  return request<any>('/gradmin/topup-records/export', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** ListUsers GET /gradmin/users */
export async function getGradminUsers(options?: { [key: string]: any }) {
  return request<any>('/gradmin/users', {
    method: 'GET',
    ...(options || {}),
  });
}

/** CreateUser POST /gradmin/users */
export async function postGradminUsers(options?: { [key: string]: any }) {
  return request<any>('/gradmin/users', {
    method: 'POST',
    ...(options || {}),
  });
}

/** UpdateUser PUT /gradmin/users/${param0} */
export async function putGradminUsersId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminUsersIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** DeleteUser DELETE /gradmin/users/${param0} */
export async function deleteGradminUsersId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminUsersIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** GetUserOrganizations GET /gradmin/users/${param0}/organizations */
export async function getGradminUsersIdOrganizations(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminUsersIdOrganizationsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/organizations`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** RemoveUserFromOrganization DELETE /gradmin/users/${param0}/organizations/${param1} */
export async function deleteGradminUsersIdOrganizationsOrgId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminUsersIdOrganizationsOrgIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, orgId: param1, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/organizations/${param1}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateUserOrganizationRole PUT /gradmin/users/${param0}/organizations/role */
export async function putGradminUsersIdOrganizationsRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminUsersIdOrganizationsRoleParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/organizations/role`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** GetUserProjects GET /gradmin/users/${param0}/projects */
export async function getGradminUsersIdProjects(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminUsersIdProjectsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/projects`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** RemoveUserFromProject DELETE /gradmin/users/${param0}/projects/${param1} */
export async function deleteGradminUsersIdProjectsProjectId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminUsersIdProjectsProjectIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, projectId: param1, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/projects/${param1}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListUserAvailableProjects GET /gradmin/users/${param0}/projects/available */
export async function getGradminUsersIdProjectsAvailable(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminUsersIdProjectsAvailableParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/projects/available`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateUserProjectRole PUT /gradmin/users/${param0}/projects/role */
export async function putGradminUsersIdProjectsRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminUsersIdProjectsRoleParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/projects/role`, {
    method: 'PUT',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ResetUserPassword POST /gradmin/users/${param0}/reset-password */
export async function postGradminUsersIdResetPassword(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postGradminUsersIdResetPasswordParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/reset-password`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** GetSpendingLimit GET /gradmin/users/${param0}/spending-limit */
export async function getGradminUsersIdSpendingLimit(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGradminUsersIdSpendingLimitParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.SpendingLimitResponse>(`/gradmin/users/${param0}/spending-limit`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** SetSpendingLimit PUT /gradmin/users/${param0}/spending-limit */
export async function putGradminUsersIdSpendingLimit(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putGradminUsersIdSpendingLimitParams,
  body: API.SetSpendingLimitRequest,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.SpendingLimitResponse>(`/gradmin/users/${param0}/spending-limit`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** DeleteSpendingLimit DELETE /gradmin/users/${param0}/spending-limit */
export async function deleteGradminUsersIdSpendingLimit(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGradminUsersIdSpendingLimitParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/spending-limit`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** UpdateUserStatus PATCH /gradmin/users/${param0}/status */
export async function patchGradminUsersIdStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.patchGradminUsersIdStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/gradmin/users/${param0}/status`, {
    method: 'PATCH',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** ListAllOrganizations GET /gradmin/users/organizations/all */
export async function getGradminUsersOrganizationsAll(options?: { [key: string]: any }) {
  return request<any>('/gradmin/users/organizations/all', {
    method: 'GET',
    ...(options || {}),
  });
}
